/**
* Created by lobin on 2020/6/18.
*/
<template>
  <div class="station">
    <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
      <a-form-model layout="inline" @submit="handleSearch" @submit.native.prevent>
        <a-form-model-item>
          <company-search
            v-model="search.company"
            placeholder="请选择所属公司"
          />
        </a-form-model-item>
        <a-form-model-item>
          <a-input v-model="search.phone" placeholder="输入电话" allowClear></a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-input v-model="search.name" placeholder="输入名称名字或者首字母" allowClear></a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-button
            type="primary"
            html-type="submit"
            icon="search"
          >
            查询
          </a-button>
        </a-form-model-item>
      </a-form-model>
      <a-divider />
      <a-table
          :loading="listloading"
          :columns="columns"
          :data-source="list"
          rowKey="_id"
          :scroll="{ x: 1500, y: $store.getters.listTableHeight + 100 }"
          :pagination="pager"
          @change="change">
        <span slot="partnerWhiteListTip" slot-scope="text">
          <a-tag v-if="text" color="#108ee9">开启中</a-tag>
          <a-tag v-else>关闭</a-tag>
        </span>
        <span slot="tts" slot-scope="text, record">
          <a-switch :loading="record.ttsloading" v-model:checked="text" @click="(checked) => changeTts(record._id, checked)" />
        </span>
        <span slot="wifiAp" slot-scope="text, record">
          <a-switch :loading="record.wifiAploading" v-model:checked="text" @click="(checked) => changeWifiAp(record._id, checked)" />
        </span>
        <span slot="device" slot-scope="text">
          <div v-for="item in text" style="padding: 5px 0;">
            <a-badge status="success" v-if="item.status === 0" />
            <a-badge status="error" v-else />
            <a-tag v-if="item.isDataChannel" color="#108ee9">主</a-tag>
            <a-tag v-else>备</a-tag>
            <span>{{ item.name }}</span>
          </div>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="modify(record._id)" v-has:modifyStation>
            修改
          </a>
          <a-divider type="vertical" />
          <a href="javascript:;" @click="showStationQrcode(record)">二维码</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              更多<a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="exchangeDevice(record._id)">数据通道主备切换</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="setPartnerWhiteList(record._id)" v-has:stationCheck>快递白名单</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="check(record)" v-has:stationCheck>检测</a>
              </a-menu-item>
              <a-menu-item v-if="['2', '3', '4'].includes(record.dtuType)">
                <a href="javascript:;" @click="runCmdText(record._id,'app_reboot')" v-has:stationCheck>重启设备</a>
              </a-menu-item>
              <a-menu-item v-if="['2','3', '4'].includes(record.dtuType)">
                <a href="javascript:;" @click="runCmdText(record._id,'app_openWifiAp')" v-has:stationCheck>开启热点</a>
              </a-menu-item>
              <a-menu-item v-if="['2','3', '4'].includes(record.dtuType)">
                <a href="javascript:;" @click="runCmdText(record._id,'app_closeWifiAp')" v-has:stationCheck>关闭热点</a>
              </a-menu-item>
              <a-menu-item v-if="['2','3', '4'].includes(record.dtuType)">
                <a href="javascript:;" @click="runCmdText(record._id,'app_refresh')" v-has:stationCheck>刷新H5</a>
              </a-menu-item>
              <a-menu-item v-if="['2','3', '4'].includes(record.dtuType)">
                <a href="javascript:;" @click="runCmdText(record._id,'app_updateApp')" v-has:stationCheck>强制更新</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </a-card>
    <staion-qrcode ref="stationQrcode" />
    <partnerWhiteList ref="partnerWhiteList" />
    <dataConnection ref="dataConnection" />
  </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex';
import partnerWhiteList from '@/views/station/partnerWhiteList.vue';
import dataConnection from './dataConnection.vue';
import { lightControl, runCmd, exchangeDevice } from '../../api/station';
import { message } from 'ant-design-vue';
import { stationModify } from '@/api/station';

const columns = [
  {
    title: '#',
    dataIndex: 'index',
    customRender: (text, row, index) => index + 1,
    key: 'index',
    width: '50px',
  },
  {
    title: '站点名称',
    dataIndex: 'name',
    ellipsis: true,
    key: 'name',
  },
  {
    title: '设备状态',
    dataIndex: 'device',
    key: 'device',
    width: 200,
    scopedSlots: { customRender: 'device' },
  },
  {
    title: '电话',
    dataIndex: 'phone',
    key: 'phone',
  },
  {
    title: '编号',
    dataIndex: 'serial',
    key: 'serial',
  },
  {
    title: '语音播报',
    dataIndex: 'tts',
    key: 'tts',
    scopedSlots: { customRender: 'tts' },
  },
  {
    title: '热点状态',
    dataIndex: 'wifiAp',
    key: 'wifiAp',
    scopedSlots: { customRender: 'wifiAp' },
  },
  // {
  //   title: '投递白名单',
  //   dataIndex: 'partnerWhiteListTip',
  //   key: 'partnerWhiteListTip',
  //   scopedSlots: { customRender: 'partnerWhiteListTip' },
  // },
  {
    title: '地址',
    dataIndex: 'address',
    key: 'address',
    ellipsis: true,
  },
  {
    title: '创建时间',
    dataIndex: 'ctime',
    key: 'ctime',
  },
  {
    title: '备注',
    key: 'remark',
    dataIndex: 'remark',
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    width: 200,
    scopedSlots: { customRender: 'action' },
  },
];
export default {
  components: {
    partnerWhiteList,
    dataConnection,
  },
  data() {
    return {
      curId: '',
      search: {
        page: 1,
        pageSize: 20,
      },
    };
  },
  created() {
    this.getList();
  },
  computed: {
    ...mapState({
      list: (state) => state.station.list,
      pager: (state) => state.station.pager,
      listloading: (state) => state['@@loading'].effects.getStationList,
    }),
    columns() {
      return columns;
    },
  },
  methods: {
    ...mapActions(['getStationList']),
    change(pagination) {
      this.search.page = pagination.current;
      this.getList();
    },
    getList() {
      this.getStationList(this.search);
    },
    modify(id) {
      this.$router.push(`/station/modify/${id}`);
    },
    showStationQrcode({ _id }) {
      this.$refs.stationQrcode.show(_id);
    },
    handleSearch() {
      this.getList();
    },
    setPartnerWhiteList(id) {
      this.$refs.partnerWhiteList.show(id);
    },
    check({ _id }) {
      this.$router.push(`/station/check/${_id}`);
    },
    // 打开数据对接弹框
    openDataConcect(id) {
      this.$refs.dataConnection.show(id);
    },
    async light(id, bo) {
      const { data: { result } } = await lightControl(id, bo);
      if (result) {
        this.$message.success('执行成功');
      } else {
        this.$message.error('执行失败');
      }
    },
    async runCmdText(id, text) {
      const { data } = await runCmd(id, text);
      if (data) {
        this.$message.success('执行成功');
      }
    },
    async exchangeDevice({ _id, device }) {
      if (device.length !== 2) {
        return this.$message.error('无法切换请手动切换');
      }
      const { data } = await exchangeDevice(_id);
      if (data) {
        this.$message.success('执行成功');
        this.getList();
      }
      return false;
    },
    changeTts(id, checked) {
      const hide = message.loading('设置中..', 0);
      this.list.forEach((item) => {
        if (item._id === id) {
          item.ttsloading = true;
        }
      });
      stationModify(id, { tts: checked }).then(() => {
        setTimeout(() => {
          message.success('修改成功');
          this.runCmdText(id,'app_refresh');
          hide();
          this.getList();
        }, 400);
      });
    },
    changeWifiAp(id, checked) {
      const hide = message.loading('设置中..', 0);
      this.list.forEach((item) => {
        if (item._id === id) {
          item.wifiAploading = true;
        }
      });
      stationModify(id, { wifiAp: checked }).then(() => {
        setTimeout(() => {
          message.success('修改成功');
          this.runCmdText(id,checked ? 'app_openWifiAp' : 'app_closeWifiAp');
          hide();
          this.getList();
        }, 400);
      });
    }
  },
};

</script>

<style lang="less" rel="stylesheet/less">
.station {
}
</style>
